/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Meeting_Report_Actions_EmptyInputs */



/**
* | output |
* | --- |
* | "Nothing is open from this conversation." |
*
* @param {Meeting_Report_Actions_EmptyInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const meeting_report_actions_empty = /** @type {((inputs?: Meeting_Report_Actions_EmptyInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Meeting_Report_Actions_EmptyInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Er staan geen actiepunten open uit dit gesprek.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Aucun point d'action ouvert pour cette conversation.")
	return /** @type {LocalizedString} */ ("Nothing is open from this conversation.")
});